"use strict";import{tag as o}from"../custom-tag.js";export function roundedStarIcon({height:r=16,width:t=16,hidden:e=!1,title:l="Rounded star"}={}){return o`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${t}
      height=${r}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${e?"true":"false"}"
      role="img"
      aria-label="${l}"
    >
      <path
        fill="currentColor"
        d="M24 12c0 1.546-1.461 2.79-2.02 4.134-.577 1.394-.444 3.301-1.495 4.35-1.051 1.05-2.957.919-4.351 1.497C14.79 22.539 13.546 24 12 24s-2.786-1.461-4.135-2.02c-1.394-.577-3.301-.445-4.35-1.495-1.05-1.05-.919-2.957-1.497-4.351C1.462 14.79 0 13.546 0 12s1.462-2.794 2.017-4.135c.578-1.394.446-3.301 1.496-4.35 1.05-1.05 2.957-.919 4.351-1.497C9.208 1.462 10.452 0 11.998 0s2.79 1.462 4.133 2.02c1.394.577 3.302.445 4.352 1.495s.917 2.957 1.495 4.351c.56 1.34 2.022 2.588 2.022 4.135"
      />
    </svg>
  `}
//# sourceMappingURL=roundedStar.js.map
